<!-- 问题 组件 -->
<template>
  <div>
    <div :class="cardData.cardMode === 'dialogue' ? 'chat-card dialogue' : 'chat-card'">
      <div class="chat-text">
        {{ titleList[cardData.step_type] || "问题" }}
      </div>
      <div class="problem">
        <div v-for="(item, index) in problemArr" :key="index">
          <div class="problem-item">
            <div class="item-label">问题{{ index + 1 }}：</div>
            <input
              v-if="isCanEdit && cardData.step_type === 'primary_troubles_qst'"
              class="item-value"
              v-model="item.title"
              type="text"
              placeholder="点击输入"
            />
            <div v-if="!isCanEdit || cardData.step_type === 'set_goal_qst'">
              {{ item.title }}
            </div>
          </div>
          <div class="problem-item" v-if="cardData.step_type === 'set_goal_qst'">
            <div class="item-label">目标{{ index + 1 }}：</div>
            <input
              v-if="isCanEdit"
              class="item-value"
              v-model="item.goal"
              type="text"
              placeholder="点击输入"
            />
            <div v-if="!isCanEdit">
              {{ item.goal }}
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="isCanEdit"
        class="confirm-btn"
        @click="confirmFn"
        v-preventReClick="3000"
      >
        确定
      </button>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "ChatProblem",
  components: {},
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {
          cardMode: "dialogue", // dialogue 对话 card 卡片
          isShowTime: true,
        };
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      problemArr: [
        {
          title: "",
          goal: "",
        },
        {
          title: "",
          goal: "",
        },
        {
          title: "",
          goal: "",
        },
      ],
      titleList: {
        primary_troubles_qst:
          "一旦你确定了对自己最重要的三个的首要问题，请把它们写下来。我会陪伴你一步步找到解决它们的方法。",
        set_goal_qst:
          "现在，你已经知道了如何设定一个SMART目标，来为之前列出的首要问题列一个SMART目标吧！。",
      },
    };
  },
  created() {},
  mounted() {
    // 如果是填写问题
    if (this.cardData.step_type === "primary_troubles_qst" && !this.isCanEdit) {
      let useData = this.nextData.step_data.survey
        ? this.nextData.step_data.survey.qstList[0].answer.title
        : false;
      if (useData) {
        this.problemArr = useData;
      }
    }
    // 如果是填写目标
    if (this.cardData.step_type === "set_goal_qst") {
      // debugger;
      if (this.isCanEdit) {
        // 如果有自定义 多选的内容 渲染多选的问题
        // if (this.cardData.step_data.instance_data[1].answer.tags?.length) {
        //   this.problemArr = this.cardData.step_data.instance_data[1].answer.tags.map(
        //     (item) => {
        //       return {
        //         title: item,
        //         goal: "",
        //       };
        //     }
        //   );
        //   return;
        //   //如果自由多选的内容渲染多选
        // } else
        if (
          this.cardData.step_data?.instance_data[
            this.cardData.step_data.instance_data.length - 1
          ]?.belongQstCode == "trouble_category_qst"
        ) {
          console.log("9999999");
          this.problemArr = this.cardData.step_data.instance_data[
            this.cardData.step_data.instance_data.length - 1
          ].answer.tags.map((item) => {
            return {
              title: item,
              goal: "",
            };
          });
          return;
        }
        // 获取下一条数据 渲染填写的问题
        let useData = this.cardData.step_data.instance_data[0].answer.title || false;
        if (useData) {
          this.problemArr = useData;
        }
      } else {
        // 如果是历史渲染 只查看的情况
        if (this.nextData.step_data.survey.qstList[0].answer.goals) {
          let useData = this.nextData.step_data.survey.qstList[0].answer.goals;
          this.problemArr = useData;
        }
      }
    }
  },
  methods: {
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: { title: this.problemArr },
              },
            ],
          },
          current: {
            //用户填写的问题内容
            troubles: this.problemArr
              .map((item) => {
                return item.title;
              })
              .filter((item) => item !== ""),
          },
        },
      };
      if (this.cardData.step_type === "set_goal_qst") {
        let hasEmptyGoal = this.problemArr.some((item) => item.goal === "");
        if (hasEmptyGoal) {
          Toast("请完成所有目标的填写");
          return false;
        }
        useData.step_data.survey.qstList[0].answer = { goals: this.problemArr };
        delete useData.step_data.current;
      }
      this.$emit("confirmFn", useData);
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  border-radius: 12px;
  padding: 10px 24px 10px 12px;
  background: #e8e3fc;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
  }
  .problem {
    .problem-item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      font-size: 12px;
      color: $text-color;
      .item-label {
        min-width: 44px;
        font-size: 12px;
        font-weight: 500;
        color: $text-color;
      }
      .item-value {
        width: 158px;
        height: 23px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        color: $text-color;
        padding: 4px;
        box-sizing: border-box;
        border: none;
        font-size: 12px;
        display: flex;
        align-items: center;

        &::placeholder {
          font-size: 10px;
          font-weight: 300;
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
  .confirm-btn {
    width: 75.94px;
    height: 25.31px;
    border-radius: 12.66px;
    background: #ad7eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10.13px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: rgba(255, 255, 255, 1);
    border: none;
    margin: 10px auto 0;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
.dialogue {
  width: 342px;
  border-radius: 12px 12px 12px 0px;
}
</style>
